import React from 'react';
import { AdminCard } from '../AdminUI';

const AdminStatCard = ({ title, value, subtitle }) => {
  return (
    <AdminCard className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-6 -top-6 h-20 w-20 rounded-full bg-cyan-500/10" />
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
        {title}
      </p>
      <p className="text-3xl font-semibold text-slate-900 dark:text-slate-100">{value}</p>
      {subtitle ? (
        <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
          {subtitle}
        </p>
      ) : null}
    </AdminCard>
  );
};

export default AdminStatCard;
